import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import UserContext, {User} from 'contexts/UserContext';

export interface WithUserProps {
    user: User;
}

export default function withUser<T extends WithUserProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithUser extends React.Component<Omit<T, keyof WithUserProps>> {
        static displayName = `withUser(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = UserContext;

        render() {
            return <WrappedComponent {...(this.props as T)} user={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithUser, WrappedComponent);
    return WithUser;
}
